import React, { useState } from 'react';
import Icon from 'components/AppIcon';


const SECTORS = ['All Sectors', 'Technology', 'Healthcare', 'Real Estate', 'Finance', 'Consumer Goods', 'Energy', 'Education', 'Food & Beverage'];
const RISK_LEVELS = ['All Risk', 'Low', 'Medium', 'High'];
const MIN_INVESTMENTS = ['Any Amount', 'Under $1K', '$1K - $5K', '$5K - $25K', '$25K+'];
const ROI_POTENTIALS = ['Any ROI', '5%+', '10%+', '20%+', '30%+'];
const SORT_OPTIONS = ['Relevance', 'ROI: High to Low', 'Min Investment: Low to High', 'Funding Stage'];

export default function FilterToolbar({ filters, onFilterChange, onSortChange, sortBy, totalCount, viewMode, onViewModeChange }) {
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);

  const handleFilterChange = (key, value) => {
    onFilterChange({ ...filters, [key]: value });
  };

  const activeFilterCount = [
    filters?.sector !== 'All Sectors',
    filters?.riskLevel !== 'All Risk',
    filters?.minInvestment !== 'Any Amount',
    filters?.roiPotential !== 'Any ROI',
    filters?.womenLed,
  ]?.filter(Boolean)?.length;

  const FilterContent = () => (
    <div className="flex flex-wrap gap-3 items-center">
      <select
        value={filters?.sector}
        onChange={e => handleFilterChange('sector', e?.target?.value)}
        className="font-caption text-sm px-3 py-2 rounded-md border bg-white focus:outline-none focus:ring-2 focus:ring-yellow-500 cursor-pointer"
        style={{ borderColor: 'var(--color-border)', color: 'var(--color-foreground)', fontFamily: 'var(--font-caption)' }}
      >
        {SECTORS?.map(s => <option key={s} value={s}>{s}</option>)}
      </select>

      <select
        value={filters?.riskLevel}
        onChange={e => handleFilterChange('riskLevel', e?.target?.value)}
        className="font-caption text-sm px-3 py-2 rounded-md border bg-white focus:outline-none focus:ring-2 focus:ring-yellow-500 cursor-pointer"
        style={{ borderColor: 'var(--color-border)', color: 'var(--color-foreground)', fontFamily: 'var(--font-caption)' }}
      >
        {RISK_LEVELS?.map(r => <option key={r} value={r}>{r}</option>)}
      </select>

      <select
        value={filters?.minInvestment}
        onChange={e => handleFilterChange('minInvestment', e?.target?.value)}
        className="font-caption text-sm px-3 py-2 rounded-md border bg-white focus:outline-none focus:ring-2 focus:ring-yellow-500 cursor-pointer"
        style={{ borderColor: 'var(--color-border)', color: 'var(--color-foreground)', fontFamily: 'var(--font-caption)' }}
      >
        {MIN_INVESTMENTS?.map(m => <option key={m} value={m}>{m}</option>)}
      </select>

      <select
        value={filters?.roiPotential}
        onChange={e => handleFilterChange('roiPotential', e?.target?.value)}
        className="font-caption text-sm px-3 py-2 rounded-md border bg-white focus:outline-none focus:ring-2 focus:ring-yellow-500 cursor-pointer"
        style={{ borderColor: 'var(--color-border)', color: 'var(--color-foreground)', fontFamily: 'var(--font-caption)' }}
      >
        {ROI_POTENTIALS?.map(r => <option key={r} value={r}>{r}</option>)}
      </select>

      <label className="flex items-center gap-2 cursor-pointer select-none">
        <div
          className={`w-5 h-5 rounded flex items-center justify-center border-2 transition-all duration-200 ${filters?.womenLed ? 'border-yellow-500 bg-yellow-500' : 'border-gray-300 bg-white'}`}
          onClick={() => handleFilterChange('womenLed', !filters?.womenLed)}
        >
          {filters?.womenLed && <Icon name="Check" size={12} color="#0B1F3B" strokeWidth={3} />}
        </div>
        <span className="font-caption text-sm font-medium flex items-center gap-1" style={{ color: 'var(--color-foreground)', fontFamily: 'var(--font-caption)' }}>
          <Icon name="Crown" size={14} color="var(--color-accent)" />
          Women-Led Only
        </span>
      </label>

      {activeFilterCount > 0 && (
        <button
          onClick={() => onFilterChange({ sector: 'All Sectors', riskLevel: 'All Risk', minInvestment: 'Any Amount', roiPotential: 'Any ROI', womenLed: false })}
          className="font-caption text-sm text-red-500 hover:text-red-700 flex items-center gap-1 transition-colors"
          style={{ fontFamily: 'var(--font-caption)' }}
        >
          <Icon name="X" size={14} color="currentColor" />
          Clear ({activeFilterCount})
        </button>
      )}
    </div>
  );

  return (
    <div className="bg-white border-b sticky top-0 z-10" style={{ borderColor: 'var(--color-border)' }}>
      <div className="px-4 md:px-6 lg:px-8 py-3">
        {/* Top row */}
        <div className="flex items-center justify-between gap-3 mb-3">
          <div className="flex items-center gap-2">
            <span className="font-caption text-sm font-medium" style={{ color: 'var(--color-muted-foreground)', fontFamily: 'var(--font-caption)' }}>
              {totalCount} opportunities
            </span>
            {activeFilterCount > 0 && (
              <span className="inline-flex items-center justify-center w-5 h-5 rounded-full text-xs font-bold text-white" style={{ background: 'var(--color-accent)', fontFamily: 'var(--font-caption)' }}>
                {activeFilterCount}
              </span>
            )}
          </div>

          <div className="flex items-center gap-2">
            <select
              value={sortBy}
              onChange={e => onSortChange(e?.target?.value)}
              className="font-caption text-sm px-3 py-2 rounded-md border bg-white focus:outline-none hidden md:block cursor-pointer"
              style={{ borderColor: 'var(--color-border)', color: 'var(--color-foreground)', fontFamily: 'var(--font-caption)' }}
            >
              {SORT_OPTIONS?.map(s => <option key={s} value={s}>{s}</option>)}
            </select>

            <div className="flex items-center border rounded-md overflow-hidden" style={{ borderColor: 'var(--color-border)' }}>
              <button
                onClick={() => onViewModeChange('grid')}
                className={`p-2 transition-colors ${viewMode === 'grid' ? 'text-white' : 'text-gray-500 hover:bg-gray-50'}`}
                style={{ background: viewMode === 'grid' ? 'var(--color-primary)' : 'white' }}
                aria-label="Grid view"
              >
                <Icon name="LayoutGrid" size={16} color="currentColor" />
              </button>
              <button
                onClick={() => onViewModeChange('list')}
                className={`p-2 transition-colors ${viewMode === 'list' ? 'text-white' : 'text-gray-500 hover:bg-gray-50'}`}
                style={{ background: viewMode === 'list' ? 'var(--color-primary)' : 'white' }}
                aria-label="List view"
              >
                <Icon name="List" size={16} color="currentColor" />
              </button>
            </div>

            <button
              className="lg:hidden flex items-center gap-1 px-3 py-2 rounded-md border font-caption text-sm transition-colors"
              style={{ borderColor: 'var(--color-border)', color: 'var(--color-foreground)', fontFamily: 'var(--font-caption)', background: mobileFiltersOpen ? 'var(--color-primary)' : 'white', color: mobileFiltersOpen ? 'white' : 'var(--color-foreground)' }}
              onClick={() => setMobileFiltersOpen(!mobileFiltersOpen)}
            >
              <Icon name="SlidersHorizontal" size={15} color="currentColor" />
              Filters
              {activeFilterCount > 0 && <span className="w-4 h-4 rounded-full text-xs flex items-center justify-center font-bold" style={{ background: 'var(--color-accent)', color: 'var(--color-primary)' }}>{activeFilterCount}</span>}
            </button>
          </div>
        </div>

        {/* Desktop filters */}
        <div className="hidden lg:block">
          <FilterContent />
        </div>

        {/* Mobile filters */}
        {mobileFiltersOpen && (
          <div className="lg:hidden pb-2">
            <FilterContent />
          </div>
        )}
      </div>
    </div>
  );
}